import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";

interface DataScansRequestsTableProps {
    scans: any[];
}

const DataScansRequestsTable: React.FC<DataScansRequestsTableProps> = ({ scans }) => {
    const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
    const navigate = useNavigate();
        
    return (
        <List sx={{ bgcolor: "#fafafa" }}>
            <ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
                <Box width="100%">
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={2}><Typography fontSize="12px">SCAN NAME</Typography></Grid>
                        <Grid item xs={1.5}><Typography fontSize="12px">TYPE</Typography></Grid>
                        <Grid item xs={1.5}><Typography fontSize="12px">CLOUD IDENTIFIER</Typography></Grid>
                        <Grid item xs={2}><Typography fontSize="12px">TARGET</Typography></Grid>
                        <Grid item textAlign="start" xs={1.5}><Typography fontSize="12px">OWNER</Typography></Grid>
                        <Grid item textAlign="start" xs={2}><Typography fontSize="12px">REQUESTED ON</Typography></Grid>
                        <Grid textAlign="start" item xs={1.5}><Typography fontSize="12px">ACTIONED BY/ REASON</Typography></Grid>
                        {/* Removed Actioned On to make space, can adjust widths if needed */}
                    </Grid>
                </Box>
            </ListItem>
            {scans.map((scan: any, index: number) => (
                <ListItem
                    key={scan.id}
                    sx={{
                        border: cardHoverIndex === index ? "1px solid #000" : "1px solid #00000000",
                        mt: 1,
                        cursor: "pointer",
                        bgcolor: scan.status === "active" || scan.status === "approved" ? "#FFFFFF" : scan.status === "rejected" ? "#F0443810" : "#FDB02210",
                        borderRadius: "8px",
                    }}
                    onClick={() => { navigate(`/datasolutions/requests/data-scans/${scan.id}`); }}
                    onMouseEnter={() => setCardHoverIndex(index)}
                    onMouseLeave={() => { setCardHoverIndex(null); }}
                >
                    <Box width="100%">
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                            <Grid item xs={2}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <RectangleIcon sx={{ color: scan.status === "active" || scan.status === "approved" ? "#12B76A" : scan.status === "rejected" ? "#F04438" : "#FDB022", bgcolor: scan.status === "active" || scan.status === "approved" ? "#12B76A" : scan.status === "rejected" ? "#F04438" : "#FDB022", width: "4px", marginRight: "8px" }} />
                                    <Typography fontSize="14px" fontFamily="Gilroy-Medium">{scan.scanName}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{scan.scanType || 'N/A'}</Typography></Grid>
                            <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular" sx={{textTransform: 'uppercase'}}>{scan.cloudProvider || 'N/A'}</Typography></Grid>
                            <Grid item xs={2}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{scan.targetTable || 'N/A'}</Typography></Grid>
                            <Grid item xs={1.5}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Avatar src={scan.ownerAvatar} alt={scan.ownerName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{scan.ownerName ? scan.ownerName.charAt(0).toUpperCase() : ''}</Avatar>
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">{scan.ownerName}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={2}>
                                <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{scan.createdAt ? moment(scan.createdAt).format("DD/MM/YYYY | hh:mm A") : 'N/A'}</Typography></Box>
                            </Grid>
                            <Grid item xs={1.5}>
                                {scan.status !== "pending" && (
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        {scan.approverName && <Avatar src={scan.approverAvatar} alt={scan.approverName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{scan.approverName.charAt(0).toUpperCase()}</Avatar>}
                                        {scan.approverName && <Typography fontSize="14px" fontFamily="Gilroy-Regular" mr={1}>{scan.approverName}</Typography>}
                                        {scan.status === "rejected" && scan.reasonForRejection && (
                                            <Tooltip title={`Reason: ${scan.reasonForRejection}`}><img src="/assets/info.svg" alt="info" /></Tooltip>
                                        )}
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </ListItem>
            ))}
        </List>
    );
};

export default DataScansRequestsTable;